import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '@/lib/api';

const ContentIdContext = createContext(undefined);
const cache = new Map();

export const useContentId = () => useContext(ContentIdContext);

// Resolves an id / slug / old slug from the URL to the real id and swaps the URL for the current slug.
export const SlugGate = ({ kind, base, param = 'id', children }) => {
  const key = useParams()[param];
  const navigate = useNavigate();
  const location = useLocation();
  const [, setTick] = useState(0);
  const cacheKey = `${kind}:${key}`;
  const resolved = cache.get(cacheKey);

  useEffect(() => {
    if (!key) return;
    const goCanonical = (d) => {
      if (d.slug && d.slug !== key) {
        navigate(`${base}/${d.slug}${location.search}${location.hash}`, { replace: true });
      }
    };
    const hit = cache.get(cacheKey);
    if (hit) { goCanonical(hit); return; }
    api.get(`/resolve/${kind}/${encodeURIComponent(key)}`)
      .then(({ data }) => {
        cache.set(cacheKey, data);
        cache.set(`${kind}:${data.slug}`, data);
        goCanonical(data);
      })
      .catch(() => cache.set(cacheKey, { id: key, slug: null }))
      .finally(() => setTick((t) => t + 1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  if (key && !resolved) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="slug-gate-loading">
        <Loader2 className="w-8 h-8 animate-spin text-ruby" />
      </div>
    );
  }
  return <ContentIdContext.Provider value={resolved?.id}>{children}</ContentIdContext.Provider>;
};
